(function () {
  'use strict';

  /* ── Namespace globale (evita conflitti su pagine con sezioni multiple) ── */
  window.TM = window.TM || {};

  /* ── Stato per sezione ────────────────────────────────────────────────── */
  var _state = {};
  function state(sid) {
    if (!_state[sid]) _state[sid] = { teamId: null, category: 'all', page: 1 };
    return _state[sid];
  }

  /* ── Helpers DOM ──────────────────────────────────────────────────────── */
  function $id(id) { return document.getElementById(id); }
  function wrap(sid) { return $id('tm-' + sid); }
  function normalizeType(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]/g, '');
  }
  function buildPaginationPages(currentPage, totalPages) {
    var pages = [];
    var lastAdded = 0;

    function pushPage(page) {
      if (page < 1 || page > totalPages || page === lastAdded) return;
      if (lastAdded && page - lastAdded > 1) pages.push('ellipsis');
      pages.push(page);
      lastAdded = page;
    }

    pushPage(1);
    for (var page = currentPage - 1; page <= currentPage + 1; page += 1) pushPage(page);
    pushPage(totalPages);

    return pages;
  }

  function syncTeamBanner(banner, count, productsAvailableLabel) {
    if (!banner) return;

    var bg = banner.querySelector('.tm-banner__bg');
    var body = banner.querySelector('.tm-banner__body');
    var logo = banner.querySelector('.tm-banner__logo');
    var eyebrow = banner.querySelector('.tm-banner__eyebrow');
    var title = banner.querySelector('.tm-banner__title');
    var countEl = banner.querySelector('.tm-banner__count');
    var bar = banner.querySelector('.tm-banner__bar');

    var bannerColor = banner.dataset.bannerColor || '#ff5500';
    var bannerImage = (banner.dataset.bannerImage || '').replace(/&amp;/g, '&');

    if (body) {
      if (bannerImage) {
        body.style.backgroundImage = 'linear-gradient(90deg, rgba(0,0,0,0.78) 0%, rgba(0,0,0,0.5) 55%, rgba(0,0,0,0.25) 100%), url("' + bannerImage + '")';
        body.style.backgroundSize = 'cover';
        body.style.backgroundPosition = 'center';
        body.style.backgroundRepeat = 'no-repeat';
        body.style.backgroundColor = 'transparent';
      } else {
        body.style.backgroundImage = 'none';
        body.style.backgroundColor = '#0d0d0d';
        body.style.backgroundSize = '';
        body.style.backgroundPosition = '';
        body.style.backgroundRepeat = '';
      }
    }

    if (bg) {
      bg.style.backgroundImage = 'none';
      bg.style.backgroundColor = 'transparent';
    }

    if (logo) {
      logo.textContent = banner.dataset.bannerLogo || logo.textContent;
      logo.style.backgroundColor = bannerColor;
    }
    if (eyebrow) eyebrow.textContent = banner.dataset.bannerEyebrow || eyebrow.textContent;
    if (title) title.textContent = banner.dataset.bannerTitle || title.textContent;
    if (bar) bar.style.backgroundColor = bannerColor;
    if (countEl && typeof count === 'number') {
      countEl.textContent = count + ' ' + (productsAvailableLabel || 'products available');
    }
  }

  /* ── Azioni pubbliche ─────────────────────────────────────────────────── */
  TM.selectTeam = function (sid, teamId) {
    var s = state(sid);
    s.teamId   = (s.teamId === teamId) ? null : teamId;
    s.category = 'all';
    s.page     = 1;
    render(sid);
    if (s.teamId) {
      setTimeout(function () {
        var el = $id('tm-prods-' + sid);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 80);
    }
  };

  TM.deselectTeam = function (sid) {
    var s = state(sid);
    s.teamId   = null;
    s.category = 'all';
    s.page     = 1;
    render(sid);
  };

  TM.setCategory = function (sid, cat) {
    var s = state(sid);
    s.category = cat;
    s.page     = 1;
    render(sid);
  };

  TM.goPage = function (sid, p) {
    state(sid).page = p;
    render(sid);
    var el = $id('tm-prods-' + sid);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  /* ── Wishlist (toggle visivo — collega la tua app) ────────────────────── */
  TM.toggleWish = function (btn, e) {
    e.preventDefault();
    btn.classList.toggle('is-wished');
    /* Dispara evento custom per integrazione con Wishlist app */
    document.dispatchEvent(new CustomEvent('tm:wishlist:toggle', {
      detail: { productId: btn.dataset.productId, wished: btn.classList.contains('is-wished') }
    }));
  };

  /* ── Add to cart (AJAX Shopify) ────────────────────────────────────────── */
  TM.addToCart = function (btn, e) {
    e.preventDefault();
    if (btn.disabled) return;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: btn.dataset.variantId, quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      btn.classList.add('is-added');
      btn.innerHTML = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg> ✓';
      /* Aggiorna il contatore del carrello del tema */
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      setTimeout(function () {
        btn.classList.remove('is-added');
        btn.innerHTML = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg> +';
        btn.disabled = false;
      }, 1600);
    })
    .catch(function () { btn.disabled = false; });
  };

  /* ── Render principale ────────────────────────────────────────────────── */
  function render(sid) {
    var s    = state(sid);
    var root = wrap(sid);
    if (!root) return;

    var pageSize    = parseInt(root.dataset.pageSize || '12', 10);
    var productsLabel = root.dataset.productsLabel || 'products';
    var productsAvailableLabel = root.dataset.productsAvailableLabel || 'products available';
    var previousLabel = root.dataset.paginationPreviousLabel || 'Previous';
    var nextLabel = root.dataset.paginationNextLabel || 'Next';
    var accentColor = s.teamId
      ? (($id('tm-tc-' + s.teamId) || {}).dataset.teamColor || '#ff5500')
      : (getComputedStyle(root).getPropertyValue('--tm-accent').trim() || '#ff5500');

    /* CSS variable colore attivo (filtri + pagination) */
    root.style.setProperty('--tm-active-color', accentColor);

    /* ── Team cards ─────────────────────────────────────────────────────── */
    root.querySelectorAll('.tm-team-card').forEach(function (card) {
      card.style.setProperty('--tc-color', card.dataset.teamColor || '#ff5500');
      card.classList.toggle('is-selected', !!(s.teamId && card.dataset.teamId === s.teamId));
      var check = $id('tm-check-' + card.dataset.teamId);
      if (check) check.style.display = (s.teamId === card.dataset.teamId) ? 'flex' : 'none';
    });

    /* ── Pulsante deseleziona ───────────────────────────────────────────── */
    var desel = $id('tm-deselect-' + sid);
    if (desel) desel.style.display = s.teamId ? '' : 'none';

    /* ── Banner ─────────────────────────────────────────────────────────── */
    var bannerAll = $id('tm-banner-all-' + sid);
    if (bannerAll) bannerAll.style.display = s.teamId ? 'none' : '';
    var activeBanner = null;
    root.querySelectorAll('.tm-banner--team').forEach(function (b) {
      var isActive = s.teamId && b.id === 'tm-banner-' + s.teamId;
      b.style.display = isActive ? '' : 'none';
      if (isActive) activeBanner = b;
    });

    /* ── Filtra prodotti ────────────────────────────────────────────────── */
    var allCards = Array.from(root.querySelectorAll('.tm-product-card'));
    var teamScopedCards = allCards.filter(function (c) {
      return !s.teamId || c.dataset.team === s.teamId;
    });

    var availableTypes = {};
    teamScopedCards.forEach(function (c) {
      var t = normalizeType(c.dataset.type);
      if (!t) return;
      availableTypes[t] = (availableTypes[t] || 0) + 1;
    });

    if (s.category !== 'all' && !availableTypes[normalizeType(s.category)]) {
      s.category = 'all';
    }

    /* ── Filtri ─────────────────────────────────────────────────────────── */
    root.querySelectorAll('#tm-filters-' + sid + ' [data-cat]').forEach(function (btn) {
      var cat = btn.dataset.cat || '';
      var isAll = cat === 'all';
      var isAvailable = isAll || !!availableTypes[normalizeType(cat)];
      var active = cat === s.category;

      btn.style.display = isAvailable ? '' : 'none';
      btn.classList.toggle('button--primary', active);
      btn.classList.toggle('button--secondary', !active);
      btn.disabled = active;
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    var visible  = allCards.filter(function (c) {
      var teamOk = !s.teamId || c.dataset.team === s.teamId;
      var catOk  = s.category === 'all' || normalizeType(c.dataset.type) === normalizeType(s.category);
      return teamOk && catOk;
    });

    /* ── Contatori ──────────────────────────────────────────────────────── */
    var countEl = $id('tm-count-' + sid);
    if (countEl) countEl.textContent = visible.length + ' ' + productsLabel;

    var allCountEl = $id('tm-all-count-' + sid);
    if (allCountEl && !s.teamId) allCountEl.textContent = visible.length + ' ' + productsAvailableLabel;

    if (s.teamId && activeBanner) {
      var activeTeamCard = $id('tm-tc-' + s.teamId);
      var cardLogo = activeTeamCard ? activeTeamCard.querySelector('.tm-tc__logo-sm') : null;
      var bannerLogo = activeBanner.querySelector('.tm-banner__logo');

      // Keep banner logo aligned with team-card logo customization.
      if (cardLogo && bannerLogo) {
        bannerLogo.textContent = cardLogo.textContent;
        bannerLogo.style.backgroundColor = getComputedStyle(cardLogo).backgroundColor;
      }

      syncTeamBanner(activeBanner, visible.length, productsAvailableLabel);
    }

    /* ── Paginazione ────────────────────────────────────────────────────── */
    var totalPages = Math.max(1, Math.ceil(visible.length / pageSize));
    if (s.page > totalPages) s.page = totalPages;
    var start = (s.page - 1) * pageSize;
    var end   = start + pageSize;

    allCards.forEach(function (c) { c.classList.remove('is-visible'); });
    visible.slice(start, end).forEach(function (c) { c.classList.add('is-visible'); });

    /* ── Empty state ────────────────────────────────────────────────────── */
    var emptyEl = $id('tm-empty-' + sid);
    if (emptyEl) emptyEl.style.display = visible.length === 0 ? '' : 'none';

    /* ── Render paginazione ─────────────────────────────────────────────── */
    var pagEl = $id('tm-pagination-' + sid);
    if (!pagEl) return;
    if (totalPages <= 1) { pagEl.innerHTML = ''; return; }

    var pages = buildPaginationPages(s.page, totalPages);
    var html = '';

    if (s.page > 1) {
      html += '<button type="button" class="previous flex items-center justify-center gap-2"'
            + ' onclick="TM.goPage(\'' + sid + '\',' + (s.page - 1) + ')"'
            + ' aria-label="' + previousLabel.replace(/"/g, '&quot;') + '">'
            + '<svg class="icon icon-arrow-left icon-sm transform stroke-1 flex-auto" viewBox="0 0 21 20" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">'
            + '<path stroke-linecap="round" stroke-linejoin="round" d="M17.996 10h-15M2.996 10l5.833 5.833M2.996 10l5.833-5.833"></path>'
            + '</svg><span class="btn-text" data-text="">' + previousLabel + '</span></button>';
    }

    pages.forEach(function (page) {
      if (page === 'ellipsis') {
        html += '<span class="page flex items-center justify-center rounded-full" aria-label="…">…</span>';
        return;
      }

      if (page === s.page) {
        html += '<span class="page current flex items-center justify-center rounded-full pointer-events-none" aria-current="page" aria-label="' + page + '">' + page + '</span>';
        return;
      }

      html += '<button type="button" class="page flex items-center justify-center rounded-full"'
            + ' onclick="TM.goPage(\'' + sid + '\',' + page + ')"'
            + ' aria-label="' + page + '"><span class="btn-text" data-text="">' + page + '</span></button>';
    });

    if (s.page < totalPages) {
      html += '<button type="button" class="next flex items-center justify-center gap-2"'
            + ' onclick="TM.goPage(\'' + sid + '\',' + (s.page + 1) + ')"'
            + ' aria-label="' + nextLabel.replace(/"/g, '&quot;') + '">'
            + '<span class="btn-text" data-text="">' + nextLabel + '</span>'
            + '<svg class="icon icon-arrow-right icon-sm transform stroke-1 flex-auto" viewBox="0 0 21 20" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">'
            + '<path stroke-linecap="round" stroke-linejoin="round" d="M3 10H18M18 10L12.1667 4.16675M18 10L12.1667 15.8334"></path>'
            + '</svg></button>';
    }

    pagEl.innerHTML = html;
  }

  /* ── Init ─────────────────────────────────────────────────────────────── */
  function init(sid) { render(sid); }

  function initAll() {
    document.querySelectorAll('.tm-wrap[data-section-id]').forEach(function (el) {
      init(el.dataset.sectionId);
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);

  /* ── Shopify Theme Editor ─────────────────────────────────────────────── */
  document.addEventListener('shopify:section:load', function (e) {
    var el = document.querySelector('.tm-wrap[data-section-id="' + e.detail.sectionId + '"]');
    if (el) init(e.detail.sectionId);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var el = document.querySelector('.tm-wrap[data-section-id="' + e.detail.sectionId + '"]');
    if (el) render(e.detail.sectionId);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var el = document.querySelector('.tm-wrap[data-section-id="' + e.detail.sectionId + '"]');
    if (el) render(e.detail.sectionId);
  });

})();
